var map = {
	"./images/nasdaq.png": 1795
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1794;


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/media ^.*\/nasdaq\.png$
// module id = 1794
// module chunks = 147